<template>
  <div class="card shadow h-100">
    <div class="card-header bg-transparent border-0">
      <h6>Lista</h6>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="tabSelecionado == 'inserido' ? 'active' : '' " href="#" @click="tab('inserido')">Inseridos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="tabSelecionado == 'removido' ? 'active' : '' " href="#" @click="tab('removido')">Removidos</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="alert alert-success fade show" role="alert" v-show="msgSuccess.length > 0">
        <div v-for="(msg, i) in msgSuccess" v-bind:key="i">{{msg}}
        </div>
      </div>
      <div v-if="listaDeclaracao.length  == 0">Nenhum item encontrado</div>
      <div
        class="table-responsive table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl"
        style="max-height:500px; overflow-y: auto"
        v-else
      >
        <table
          class="table table-borderless table-hover table-sm table-md table-lg table-xl table-condensed"
        >
          <thead>
            <tr class="d-flex">
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado != 'inserido'">Data Deleção</th>
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">Ação</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Situação</th>
              <th class="col-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">Empresa</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">CNPJ</th>
              <th class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1">Data</th>
              <th class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">Remuneração</th>
            </tr>
          </thead>
          <tbody>
            <tr class="d-flex" v-for="(declaracao) of listaDeclaracao" v-bind:key="declaracao.id">
              
              <td
                class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1"  v-show="tabSelecionado != 'inserido'"
              >{{declaracao.data_delecao | formatDatetime}}</td>
              <td class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1" v-show="tabSelecionado == 'inserido'">
                <button
                  type="button"
                  class="btn btn-xl btn-lg btn-md btn-sm btn-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Excluir Declaração"
                  v-show="declaracao.permite_deletar == 1"
                  @click="showModal(declaracao)"
                >
                  <li class="oi oi-trash"></li>
                </button>
              </td>
              <td class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2">
                <span
                  class="badge badge-mod-success"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Declaração Cadastrada"
                  v-if="declaracao.situacao == 'Cadastrado'"
                >
                  <li class="oi oi-check"></li>{{declaracao.situacao}}
                </span>
                
                <span
                  class="badge badge-mod-danger"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Declaração removida"
                  v-else-if="declaracao.situacao == 'Removido'"
                >
                  <li class="oi oi-trash"></li> Removido
                </span>
                <span
                  class="badge badge-mod-warning"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Declaração será cadastrada somente no dia seguinte"
                  v-else
                >
                  <li class="oi oi-clock"></li>{{declaracao.situacao}}
                </span>
              </td>
              <td class="col-4 col-xl-4 col-lg-4 col-md-4 col-sm-4">{{declaracao.nome_empresa}}</td>
              <td
                class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2"
              >{{declaracao.cnpj_empresa | formatCNPJ}}</td>
              <td
                class="col-1 col-xl-1 col-lg-1 col-md-1 col-sm-1"
              >{{declaracao.data_inicio_vigencia | formatDate}}</td>
              <td
                class="col-2 col-xl-2 col-lg-2 col-md-2 col-sm-2"
              >{{declaracao.valor_base_inss | formatMoney}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <modal v-show="isModalVisible" @close="closeModal">
      <span slot="header">Deleção de Declaração INSS</span>
      <div slot="body">
        
        <div class="row">
          <div class="col-11">
            <label class="label-black">Deseja realmente efetuar a deleção da declaração?</label>
          </div>
        </div>
        <br/>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Empresa:</label>
            <span>{{declaracao.nome_empresa}}</span>
          </div>
          <div class="col-11">
            <label class="label-black">Data:</label>
            <span>{{declaracao.data_inicio_vigencia | formatDate}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-11">
            <label class="label-black">Remuneração:</label>
            <span>{{declaracao.valor_base_inss | formatMoney}}</span>
          </div>
        </div>
      </div>
      <div slot="footer">

        <button class="btn btn-danger" @click="closeModal()">
        <li class="oi oi-circle-x"></li> Não
      </button>
      <button class="btn btn-secondary" @click="deletarDeclaracao()">
        <li class="oi oi-check"></li> Sim
      </button>
      </div>
    </modal>
  </div>
</template>

<script>
import money from "../../utils/InputMoney";
import competencia from "../../utils/InputCompetencia";
import cnpj from "../../utils/InputCnpj";
import http from "./../../../axios";
import modal from "../../utils/Modal";

export default {
  name: "DeclaracaoInssListaDetalhada",
  components: {
    money: money,
    competencia: competencia,
    cnpj: cnpj,
    modal: modal
  },
  data() {
    return {
      listaDeclaracao: [],
      listaDeclaracaoInsert: [],
      listaDeclaracaoDelete: [],
      isModalVisible: false,
      carregando: false,
      showErrors: false,
      msgSuccess: [],
      declaracao: {},
      tokens: {},
      tabSelecionado: "inserido"
    };
  },
  created: function() {
    this.getTokens();
    this.getListaDeclaracao();
  },
  methods: {
    tab: function(selecionado){
      this.tabSelecionado = selecionado;
      if(this.tabSelecionado == "inserido"){
        this.listaDeclaracao = this.listaDeclaracaoInsert;
      }else{
        this.listaDeclaracao = this.listaDeclaracaoDelete;
      }
    },
    showModal(declaracaoTemp) {
      this.declaracao = { };
      this.declaracao = declaracaoTemp;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getListaDeclaracao: function() {
      this.$Progress.start();
      this.listaDeclaracao = [];
      this.listaDeclaracaoInsert = [];
      this.listaDeclaracaoDelete = [];
      http
        .get(`api/cooperado/${this.tokens.id}/declaracao/lista`, {
          headers: { "token-cooperado-api": this.tokens.token }
        })
        .then(r => {
          if (r.data.statusCode == 200) {
            for(var i = 0; i < r.data.result.length; i++){
              if(r.data.result[i].situacao == "Removido"){
                this.listaDeclaracaoDelete.push(r.data.result[i]);
              }else{
                this.listaDeclaracaoInsert.push(r.data.result[i]);
              }
            }
            if(this.tabSelecionado == "inserido"){
              this.listaDeclaracao = this.listaDeclaracaoInsert;
            }else{
              this.listaDeclaracao = this.listaDeclaracaoDelete;
            }
          } else {
            this.listaDeclaracao = [];
            this.listaDeclaracaoInsert = [];
            this.listaDeclaracaoDelete = [];
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.$Progress.fail();
          if (error.response) {
            if (error.response.status >= 500) {
              this.$router.push("/");
            }
          } else if (error.request) {
            this.$router.push("/");
          } else {
            console.log("Error", error.message);
            this.$router.push("/");
          }
        });
    },
    deletarDeclaracao: function() {
      this.msgSuccess = [];
      this.closeModal()
      this.$Progress.start();
        http
          .delete(`api/cooperado/${this.tokens.id}/declaracao/${this.declaracao.id}`, {
            headers: { "token-cooperado-api": this.tokens.token }
          })
          .then(r => {
            if (r.data.statusCode == 200) {
              this.msgSuccess.push("Declaração deletada com sucesso!");
              this.$Progress.finish()
              this.getListaDeclaracao();
            }
          })
          .catch(error => {
            this.$Progress.fail()
            if (error.response) {
              if (error.response.status >= 500) {
                this.$router.push("/");
              }else{
                this.$router.push("/DeclaracaoInssLista");
              }
            } else if (error.request) {
                this.$router.push("/");
            } else {
              console.log("Error", error.message);
                this.$router.push("/");
            }
          });
    },
    getTokens: function() {
      this.tokens = this.$cooperadowebapi.tokens.get("usuario");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/declaracao/DeclaracaoInssListaDetalhada.vue